import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import Modal from '$/components/global/modal';
import BixButton from '$/components/global/bixButton';
import PeopleSearchBox from '$/components/global/peopleSearchBox';
import { PlannerTranscriptionService, TranscriptionsAdminService } from '$/services';
import * as Bixby from '$/core';
import './CreateApprovalTask.scss';

export interface ICreateApprovalTaskProps {
  currentTranscription: Bixby.Models.AdminCompanyTranscription | undefined;
  isCreatingApprovalTask: boolean;
  onCloseModal: () => void;
}

const CreateApprovalTask: React.FC<ICreateApprovalTaskProps> = props => {
  const { currentTranscription, isCreatingApprovalTask, onCloseModal } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [assignees, setAssignees] = useState<string[]>([]);

  const initialCreateApprovalTaskValues = {};

  const formikRef = useRef<FormikProps<any>>(null);

  const schema = Yup.object({});

  if (!currentTranscription) {
    return null;
  }

  const handleCloseModal = () => {
    if (formikRef && formikRef.current) {
      formikRef.current.resetForm();
    }

    setAssignees([]);

    onCloseModal();
  };

  const handleCreateApprovalTask = async (transcription: Bixby.Models.AdminCompanyTranscription) => {
    setError(undefined);
    setIsLoading(true);

    let plannerTranscriptionApproveId: string | undefined = undefined;
    try {
      // Create planner approval task
      plannerTranscriptionApproveId = await PlannerTranscriptionService.addTranscriptionApproveTaskAsync(
        transcription.companyId,
        transcription.companyBixbyId,
        transcription.transcriptionId,
        transcription.hasPrivateDeclaration,
        assignees
      );

      await TranscriptionsAdminService.savePlannerApprovalTask(
        transcription.transcriptionId,
        plannerTranscriptionApproveId
      );

      handleCloseModal();
    } catch (e: any) {
      if (plannerTranscriptionApproveId) {
        // Error uploading transcript files. Delete planner transcription approval task
        await PlannerTranscriptionService.deleteTranscriptionTaskAsync(plannerTranscriptionApproveId);
      }

      setError('Error saving planner approval task');
    } finally {
      setIsLoading(false);
    }
  };

  const createTaskForm = (
    <div className="create-approval-task-modal">
      <Modal title={'Create Approval Task'} forForm onClose={handleCloseModal} active={isCreatingApprovalTask}>
        <div className="create-approval-task">
          <Formik
            innerRef={formikRef}
            initialValues={initialCreateApprovalTaskValues}
            validationSchema={schema}
            onSubmit={async () => {
              await handleCreateApprovalTask(currentTranscription);
            }}
            render={({ handleSubmit }) => (
              <form className="create-task-form" onSubmit={handleSubmit}>
                <div>
                  <PeopleSearchBox
                    title="Assign Task"
                    showMnpiUsers={currentTranscription?.hasPrivateDeclaration}
                    onChange={(ids: string[]) => setAssignees(ids)}
                    maxMenuHeight={120}
                  />
                </div>
                {error && <p className="error">{error}</p>}
                <BixButton useSmall type="submit" disabled={isLoading} useLoading isLoading={isLoading}>
                  Allocate Task
                </BixButton>
              </form>
            )}></Formik>
        </div>
      </Modal>
    </div>
  );

  return <div>{createTaskForm}</div>;
};

const mapDispatchToProps = () => ({});

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateApprovalTask);
